import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";
import { ItemsSectorWithCity } from "@rf-l1/items-autocomplete/MxItemsSectorWithCity";

const prepareLocationsToClient = (
  res: IPropertyDetailsResponse
): ILocationsState => {
  const locations: ILocationsState = {
    city: [],
    sector: [],
    log: 0,
    lat: 0,
    address: "",
    reference: ""
  };

  if (res?.sector) {
    locations.sector.push({
      label: res?.sector,
      value: res?.sector_id,
      extraData: {
        city: {
          description: res.city,
          id: res.city_id
        }
      }
    });
  }

  if (res?.city) {
    locations.city.push({
      label: res?.city,
      value: res?.city_id
    });
  }

  locations.log = res?.longitude ? Number(res?.longitude) : -70.4841116135334;
  locations.lat = res?.latitude ? Number(res?.latitude) : 19.049050125598214;
  locations.address = res?.address ?? "";
  locations.reference = res?.reference ?? "";

  return locations;
};

export default prepareLocationsToClient;
// TODO - Check if this is the correct return type
interface ILocationsState {
  sector: ItemsSectorWithCity[] | any;
  city: I_GENERIC_ITEMS[] | any;
  log: number;
  lat: number;
  address: string;
  reference: string;
}
